/**
 * Sales Order Status Constants
 *
 * These constants define which SO statuses indicate "complete" orders
 * where stock is no longer reserved.
 */

// Statuses where the order is complete and stock is NOT reserved
// Extend this list to add more "completed" statuses in future
export const COMPLETED_SO_STATUSES = ['shipped', 'invoiced'];

/**
 * Check if a sales order status indicates reserved stock
 * @param {string} status - The sales order status
 * @returns {boolean} True if stock should be considered reserved
 */
export const isStockReserved = (status) => {
  return !COMPLETED_SO_STATUSES.includes(status?.toLowerCase());
};

/**
 * Status display configuration for UI
 */
export const SO_STATUS_CONFIG = {
  draft: { label: '草稿', color: 'default', reservesStock: true },
  confirmed: { label: '已确认', color: 'primary', reservesStock: true },
  processing: { label: '处理中', color: 'info', reservesStock: true },
  pending: { label: '待处理', color: 'warning', reservesStock: true },
  shipped: { label: '已发货', color: 'success', reservesStock: false },
  invoiced: { label: '已开票', color: 'success', reservesStock: false },
  cancelled: { label: '已取消', color: 'error', reservesStock: false }
};
